import { services } from "@/mocks/homeData";

const serviceLinks: Record<string, string> = {
  "Kredyty hipoteczne": "/kredyt-hipoteczny-sanok",
  "Kredyty gotówkowe": "/kredyt-gotowkowy-sanok",
  "Kredyty firmowe": "/kredyt-firmowy-sanok",
  Refinansowanie: "/refinansowanie-kredytu-sanok",
};

export default function ServicesSection() {

  return (
    <section className="w-full bg-background-100 py-16 md:py-24">
      <div className="px-6 md:px-12 lg:px-20 xl:px-24 max-w-[1440px] mx-auto">

        {/* Nagłówek */}
        <div className="text-center max-w-2xl mx-auto mb-14 md:mb-18">
          <span className="text-[11px] font-semibold tracking-[0.25em] uppercase text-primary-500 mb-4 block animate-fade-in-up">
            Oferta
          </span>
          <h2 className="font-heading text-[2.2rem] md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-4 animate-fade-in-up animation-delay-100">
            Kompleksowe finansowanie kredytowe
          </h2>
          <p className="text-base text-foreground-600 leading-relaxed animate-fade-in-up animation-delay-200">
            Oferuję szeroki zakres usług finansowych dopasowanych do potrzeb klientów indywidualnych i przedsiębiorców.
          </p>
        </div>

        {/* Grid usług – desktop/tablet: grid 2-3 kolumny; mobile: poziomy slider */}
        <div className="hidden sm:grid grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {services.map((service, index) => (
            <div
              key={service.title}
              className="group relative bg-background-50 rounded-2xl p-6 md:p-8 border border-background-200/60 hover:border-primary-300/60 hover:shadow-xl hover:-translate-y-1 transition-all duration-400 animate-fade-in-up"
              style={{ animationDelay: `${(index + 1) * 100}ms` }}
            >
              {/* Hover glow */}
              <div className="absolute inset-0 rounded-2xl bg-primary-500/5 opacity-0 group-hover:opacity-100 transition-opacity duration-400 pointer-events-none" />

              <div className="relative z-10">
                {/* Ikona w eleganckim outline circle */}
                <div className="w-12 h-12 flex items-center justify-center rounded-full border border-primary-500/30 bg-primary-50/50 mb-5 group-hover:bg-primary-500 group-hover:border-primary-500 transition-all duration-300">
                  <i className={`${service.icon} text-lg text-primary-500 group-hover:text-white transition-colors duration-300`} />
                </div>

                <h3 className="font-heading text-lg font-semibold text-foreground-950 mb-3 group-hover:text-primary-600 transition-colors duration-300">
                  {service.title}
                </h3>

                <p className="text-sm text-foreground-600 leading-[1.7] mb-5">
                  {service.description}
                </p>

                {serviceLinks[service.title] && <a href={serviceLinks[service.title]} className="inline-flex mr-4 text-sm font-semibold text-primary-600 hover:text-primary-500">Dowiedz się więcej <i className="ri-arrow-right-line ml-1" /></a>}

                <a
                  href="/oferta"
                  className="inline-flex items-center gap-1.5 mr-4 text-sm font-semibold text-primary-600 hover:text-primary-500 transition-colors"
                >
                  Sprawdź ofertę
                  <i className="ri-arrow-right-line" />
                </a>
                <a
                  href="tel:698084044"
                  className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors cursor-pointer group/btn"
                >
                  Zadzwoń i dowiedz się więcej
                  <i className="ri-phone-line group-hover/btn:translate-x-1 transition-transform duration-200" />
                </a>
              </div>
            </div>
          ))}
        </div>

        {/* Mobile slider */}
        <div className="sm:hidden">
          <div className="flex overflow-x-auto snap-x snap-mandatory px-0 gap-4 pb-4"
          style={{
            WebkitOverflowScrolling: 'touch',
            scrollbarWidth: 'none',
            msOverflowStyle: 'none',
          }}
          >
            {services.map((service) => (
              <div
                key={service.title}
                className="group relative bg-background-50 rounded-2xl p-5 border border-background-200/60 flex-shrink-0 w-[280px] snap-start first:ml-6 last:mr-6"
              >
                <div className="w-10 h-10 flex items-center justify-center rounded-full border border-primary-500/30 bg-primary-50/50 mb-4">
                  <i className={`${service.icon} text-base text-primary-500`} />
                </div>

                <h3 className="font-heading text-base font-semibold text-foreground-950 mb-2">
                  {service.title}
                </h3>

                <p className="text-[13px] text-foreground-600 leading-[1.65] mb-4">
                  {service.description}
                </p>

                {serviceLinks[service.title] && <a href={serviceLinks[service.title]} className="inline-flex mr-3 text-[13px] font-semibold text-primary-600">Dowiedz się więcej <i className="ri-arrow-right-line ml-1" /></a>}

                <a
                  href="/oferta"
                  className="inline-flex items-center gap-1 mr-3 text-[13px] font-semibold text-primary-600"
                >
                  Sprawdź ofertę
                  <i className="ri-arrow-right-line" />
                </a>
                <a
                  href="tel:698084044"
                  className="inline-flex items-center gap-1.5 text-[13px] font-medium text-primary-500 transition-colors cursor-pointer"
                >
                  Zadzwoń i dowiedz się więcej
                  <i className="ri-phone-line" />
                </a>
              </div>
            ))}
          </div>

          {/* Wzmianka o przesuwaniu */}
          <div className="flex items-center justify-center gap-2 mt-1 mb-2 text-foreground-400">
            <i className="ri-arrow-left-right-line text-sm" />
            <span className="text-xs font-medium tracking-wide">Przesuń w bok, aby zobaczyć więcej</span>
            <i className="ri-arrow-left-right-line text-sm" />
          </div>
        </div>

        {/* CTA */}
        <div className="text-center mt-12 md:mt-16 animate-fade-in-up animation-delay-700">
          <a
            href="tel:698084044"
            className="inline-flex px-8 py-3.5 bg-primary-500 text-white font-semibold rounded-full hover:bg-primary-600 hover:scale-105 active:scale-95 transition-all duration-300 shadow-lg shadow-primary-500/20 whitespace-nowrap cursor-pointer"
          >
            Zadzwoń i poznaj pełną ofertę
          </a>
        </div>
      </div>

      <style>{`
        .scrollbar-hide {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
        .scrollbar-hide::-webkit-scrollbar {
          display: none;
        }
      `}</style>
    </section>
  );
}
